import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "app-download-links-wrapper" }
const _hoisted_2 = { class: "app-download-description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MobileAppLink = _resolveComponent("MobileAppLink")!
  const _component_ModalContainer = _resolveComponent("ModalContainer")!

  return (_openBlock(), _createBlock(_component_ModalContainer, { "modal-content-class": "mobile-app-link-modal-content" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mobileAppTypeList, (mobileApp) => {
          return (_openBlock(), _createBlock(_component_MobileAppLink, {
            key: mobileApp,
            class: "item",
            "img-uri": _ctx.mobileAppLinkConfig[mobileApp].icon,
            "img-qr-uri": _ctx.mobileAppLinkConfig[mobileApp].qr[_ctx.storeType],
            "mobile-app-name": _ctx.mobileAppLinkConfig[mobileApp].name,
            onClick: ($event: any) => (_ctx.openStoreUrl(mobileApp))
          }, null, 8, ["img-uri", "img-qr-uri", "mobile-app-name", "onClick"]))
        }), 128)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('message.show_qrcode_when_mouse_over')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('message.move_appdownload_page_when_click')), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}